import { Asset, Column, Upright } from '../asset/asset.dto';
import { Inspection } from '../inspection/inspection.dto';
import { Issue, LocalizedRiskLevel } from '../issue/issue.dto';
import { UprightElevationView, UprightElevationViewRequest, WarehouseSourceRef } from './warehouse-data-source';
import { normalizeInspection } from './system-view.mapper';

export interface UprightElevationStateSlice {
  assets: Asset[];
  uprights: Upright[];
  columns: Column[];
  issues: Issue[];
}

export function buildUprightElevationView(
  slice: UprightElevationStateSlice,
  req: UprightElevationViewRequest,
  ref: WarehouseSourceRef,
  priorities: LocalizedRiskLevel[],
  inspection: Inspection = req.inspection,
): UprightElevationView {
  const assetsById = new Map<string, Asset>((slice.assets ?? []).filter((asset) => !!asset).map((asset) => [String(asset._id), asset]));
  const assets = [...(slice.assets ?? [])];
  const orderedAssetIds = [...new Set([...req.assetIds.map(String), ...assets.map((asset) => String(asset._id))])];
  const assetOrder = new Map(orderedAssetIds.map((assetId, index) => [assetId, index]));
  const uprights = [...(slice.uprights ?? [])]
    .sort((a, b) => (assetOrder.get(String(a.assetId)) ?? Number.MAX_SAFE_INTEGER) - (assetOrder.get(String(b.assetId)) ?? Number.MAX_SAFE_INTEGER))
    .map((upright) => ({ ...upright, clientCode: assetsById.get(String(upright.assetId))?.clientCode }));

  return {
    assets,
    uprights,
    columns: (slice.columns ?? []).map((column) => ({
      ...column,
      palletLevels: column.palletLevels ? [...column.palletLevels] : column.palletLevels,
    })),
    issues: req.includeIssues ? [...(slice.issues ?? [])] : [],
    priorities,
    inspection: normalizeInspection(inspection),
    source: ref,
  };
}
